import { Mail, Phone, MapPin, ExternalLink } from "lucide-react";
import logoMombongo from "@/assets/logo-mombongo.png";

const PLATFORM = ["Tableau de bord", "Marché", "Bourse", "Financement", "Academia"];
const COMPANY = ["À propos", "Presse", "Partenaires", "Carrières"];

function noop(e: React.MouseEvent) { e.preventDefault(); }

export function Footer() {
  return (
    <footer className="border-t border-gray-200 bg-white mt-6">
      <div className="max-w-[1400px] mx-auto px-8 py-5">
        <div className="grid grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <img src={logoMombongo} alt="Mombongo" className="h-8 w-auto object-contain mb-3" />
            <p className="text-[11px] text-gray-400 leading-relaxed">
              La plateforme coopérative agricole de la RDC. Connectons agriculteurs, investisseurs et marchés.
            </p>
            <p className="text-[10px] text-gray-400 mt-3">© {new Date().getFullYear()} Mombongo Coopérative</p>
          </div>

          {/* Platform links */}
          <div>
            <p className="text-[9px] font-bold text-gray-500 uppercase tracking-widest mb-2.5">Plateforme</p>
            <ul className="space-y-1.5">
              {PLATFORM.map((l) => (
                <li key={l}>
                  <a href="#" onClick={noop} className="text-[12px] text-gray-400 hover:text-gray-700 transition">
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company links */}
          <div>
            <p className="text-[9px] font-bold text-gray-500 uppercase tracking-widest mb-2.5">Entreprise</p>
            <ul className="space-y-1.5">
              {COMPANY.map((l) => (
                <li key={l}>
                  <a href="#" onClick={noop} className="text-[12px] text-gray-400 hover:text-gray-700 transition">
                    {l}
                  </a>
                </li>
              ))}
            </ul>
            <a
              href="#"
              onClick={noop}
              className="inline-flex items-center gap-1.5 mt-4 text-[11px] font-semibold text-green-700 hover:text-green-800 transition"
            >
              <ExternalLink className="w-3 h-3" /> Espace Admin
            </a>
          </div>

          {/* Contact */}
          <div>
            <p className="text-[9px] font-bold text-gray-500 uppercase tracking-widest mb-2.5">Contact</p>
            <ul className="space-y-2">
              <li className="flex items-center gap-2">
                <Mail className="w-3 h-3 text-gray-400 shrink-0" />
                <a href="mailto:contact@mombongo.com" className="text-[12px] text-gray-400 hover:text-gray-700 transition">
                  contact@mombongo.com
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="w-3 h-3 text-gray-400 shrink-0" />
                <span className="text-[12px] text-gray-400">+243 99 000 0000</span>
              </li>
              <li className="flex items-center gap-2">
                <MapPin className="w-3 h-3 text-gray-400 shrink-0" />
                <span className="text-[12px] text-gray-400">Kinshasa, RDC</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="flex items-center justify-end mt-5 pt-4 border-t border-gray-100">
          <div className="flex items-center gap-1.5">
            <span className="w-1.5 h-1.5 bg-green-500 rounded-full animate-pulse-dot" />
            <span className="text-[10px] text-gray-400 font-semibold">Tous les systèmes opérationnels</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export function MobileFooter() {
  return (
    <div className="border-t border-gray-100 bg-white px-4 py-5 text-center">
      <p className="text-[10px] text-gray-400">© {new Date().getFullYear()} Mombongo Coopérative</p>
      <div className="flex items-center justify-center gap-4 mt-2">
        <a href="mailto:contact@mombongo.com" className="text-[10px] text-gray-400 hover:text-gray-600 transition">
          Contact
        </a>
      </div>
    </div>
  );
}
